import { z } from 'zod'

import { WidgetTypes } from 'apps/growthTools/models/Widget/constants'
import { ChannelType } from 'common/core/constants/ChannelType'

enum SystemTriggerType {
  DEFAULT_REPLY = 'default_reply',
  FOLLOW_UPS = 'follow_ups',
  WELCOME_MESSAGE = 'welcome_message',
  STORY_MENTION_REPLY = 'story_mention_reply',
  ICEBREAKERS = 'icebreakers',
  KEYWORDS_RULES = 'keywords_rules',
  INTENT_RULES = 'intent_rules',
  TRIGGER_RULES = 'trigger_rules',
}

export const triggerStatisticSchema = z.object({
  trigger_title: z.string(),
  trigger_type: z.union([z.enum(WidgetTypes), z.enum(SystemTriggerType)]),
  flow_ns: z.string(),
  sent_unq: z.number(),
  sent_unq_last_7_days: z.number(),
  ctr: z.number(),
  flow_title: z.string(),
  channel: z.enum(ChannelType).nullable(),
})

export const analyticsWidgetSchema = z.object({
  ts_outdated: z.number().nullable(),
  is_generating: z.boolean(),
  triggers_stats: z.array(triggerStatisticSchema).nullable(),
})
